import React from "react";
import { ReactComponent as Logo } from "assets/img/vectors/logo/jobcase.svg";


const JobcaseLogoSvg = () => (
    <Logo style={{"width":"150px"}} />
)

export default JobcaseLogoSvg;